<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    persistent
    max-width="500"
    content-class="confirm-dialog"
  >
    <v-card>
      <v-card-title class="text-h6">
        <div v-html="title" />
      </v-card-title>
      <v-card-text>
        <div v-html="description" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="onCancel">
          {{ cancelText }}
        </v-btn>
        <v-btn color="primary" @click="onAccept">
          {{ acceptText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.v-card {
  background: var(--kln-bg-surface) !important;
}
.v-card ::v-deep .v-card__title {
  color: var(--kln-text) !important;
}
.v-card ::v-deep .v-card__text {
  color: var(--kln-text-muted) !important;
}
</style>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Confirmar',
    },
    description: {
      type: String,
      default: '',
    },
    acceptText: {
      type: String,
      default: 'Aceptar',
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
  },
  methods: {
    onAccept() {
      this.$emit('input', false);
      this.$emit('accept');
    },
    onCancel() {
      this.$emit('input', false);
      this.$emit('cancel');
    },
  },
};
</script>
